import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

export const Manifesto = () => {
  const { t } = useLanguage();

  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 md:py-60">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid grid-cols-12">
        <Reveal className="col-span-12 md:col-span-9 md:col-start-2 lg:col-span-7 lg:col-start-3">
          <p
            data-testid="manifesto-text"
            className="font-normal text-3xl md:text-5xl lg:text-[3.4rem] tracking-tight leading-[1.25] text-foreground"
          >
            {t.manifesto}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
